export const useQueries = () => {
  const query = Object.fromEntries(new URLSearchParams(window.location.search).entries());

  return query;
};
